
import { defineComponent } from "vue";
import { v4 as uuid } from "uuid";

export default defineComponent({
  name: "FloatingLabel",
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    formatted: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    searchText: "",
    id: uuid(),
  }),
  watch: {
    searchText(val) {
      if (val !== this.formatted) {
        this.$emit("update", val);
      }
    },
    formatted(val) {
      this.searchText = val;
    },
  },
});
